<template>
    <div>
        <b-container v-if="choices.length > 0" fluid class="my-2">
            <b-row
                v-for="choice in choices"
                :key="`choice-${choice.id}`"
                class="mb-3"
            >
                <b-col sm="3" xl="2">
                    <div class="text-center">
                        <b-button
                            v-if="canEditSurvey"
                            variant="warning"
                            size="sm"
                            v-b-tooltip.hover
                            title="Editar Opción"
                            @click="onUpdateChoice(choice)"
                        >
                            <b-icon-pencil />
                        </b-button>

                        <b-button
                            v-if="canEditSurvey"
                            variant="danger"
                            size="sm"
                            class="ml-2"
                            v-b-tooltip.hover
                            title="Eliminar Opción"
                            @click="onDeleteChoice(choice)"
                        >
                            <b-icon-trash-fill />
                        </b-button>
                    </div>
                </b-col>
                <b-col sm="9" xl="10" align-self="center">
                    <b-form-radio
                        v-if="answerType === 'simple'"
                        :name="`question-${questionId}`"
                    >
                        <span :class="{'correct-answer': choice.isCorrect }">
                            {{ choice.body }}
                        </span>
                    </b-form-radio>

                    <b-form-checkbox
                        v-if="answerType === 'multiple'"
                    >
                        <span :class="{'correct-answer': choice.isCorrect }">
                            {{ choice.body }}
                        </span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    name: 'SurveyQuestionChoices',
    props: {
        choices: Array,
        answerType: String,
        questionId: Number
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedSurveyObject',
            'selectedCrudObject'
        ]),
        ...mapGetters([
            'isUserStudenTeacherOrBetter',
            'canEditSurvey'
        ])
    },
    methods: {
        ...mapActions([
            'deleteSiteSurveyQuestionChoice',
            'readSingleSiteTeacherSurvey'
        ]),
        onUpdateChoice (choice) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', choice)
            this.$store.commit('SET_SELECTED_SURVEY_QUESTION_ID', this.questionId)
            this.$bvModal.show('modal-create-survey-question-choice')
        },
        async onDeleteChoice (choice) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', choice)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    '¿Esta seguro que desea eliminar esta opción?',
                    {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDeleteChoice()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDeleteChoice () {
            var loader = this.$loading.show()
            try {
                const payloadData = {
                    courseSiteId: this.activeSite.id,
                    surveyQuestionId: this.questionId,
                    surveyId: this.selectedSurveyObject.id,
                    choiceId: this.selectedCrudObject.id
                }
                await this.deleteSiteSurveyQuestionChoice(payloadData)
                var reloadPayload = { courseSiteId: this.activeSite.id, surveyId: this.selectedSurveyObject.id }
                await this.readSingleSiteTeacherSurvey(reloadPayload)
                this.$root.infoToast('La opción ha sido eliminada exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar la opción, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        }
    }
}
</script>
